import { render, staticRenderFns } from "./PageAdminDocumentKeywords.vue?vue&type=template&id=7f28d91e"
import script from "./PageAdminDocumentKeywords.vue?vue&type=script&lang=js"
export * from "./PageAdminDocumentKeywords.vue?vue&type=script&lang=js"
import style0 from "./PageAdminDocumentKeywords.vue?vue&type=style&index=0&id=7f28d91e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports